import type { FormControlLabelProps } from "@mui/material";
import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import type { MouseEventHandler } from "react";
import type { FieldPathByValue, FieldValues } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import { usePopover } from "../../../../utils/hooks/use-popover";
import type { ElementTracking } from "../../../analytics/analytics";
import { useElementTracking } from "../../../analytics/analytics";
import { ColourPicker } from "../colour-picker/colour-picker";

export const CeColourField = <TFieldValues extends FieldValues>({
  analyticsCategory,
  name,
  label,
}: {
  name: FieldPathByValue<TFieldValues, string | null | undefined>;
  label: string;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
} & ElementTracking): React.JSX.Element => {
  const methods = useFormContext<TFieldValues>();

  const id = `${name}-picker`;

  const colour = methods.watch(name);

  const handleClick: MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    popover.handleOpen();
  };

  const popover = usePopover<HTMLDivElement>();

  const analytics = useElementTracking(analyticsCategory, id);

  return (
    <Controller
      control={methods.control}
      name={name}
      render={({ field }) => (
        <>
          <FormControl fullWidth>
            <InputLabel htmlFor={id}>{label}</InputLabel>
            <OutlinedInput
              inputRef={popover.anchorRef}
              type="color"
              id={id}
              inputProps={analytics}
              value={colour}
              label={label}
              onClick={handleClick}
            />
          </FormControl>
          <ColourPicker popover={popover} onChange={field.onChange} colour={colour} />
        </>
      )}
    />
  );
};
